import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {  ReferrerPortalRoutingModule } from './referrer-portal-routing.module';
import {  ReferrerPortalComponent } from './referrer-portal.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsFormModule } from '../forms/forms-form/forms-form.module';
import { FileManagerModule } from '../file-manager/file-manager.module';
import { FileManagerViewModule } from '../file-manager/file-manager-view/file-manager-view.module';
import { TdoControlsModule } from 'src/app/tdo-controls/tdo-controls.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReferrerPortalHomeComponent } from './referrer-portal-home/referrer-portal-home.component';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { ReferrerPortalReferralDetailComponent } from './referrer-portal-referral-detail/referrer-portal-referral-detail.component';
import { LucideIconsModule } from '../../shared/lucide-icons.module';

@NgModule({
    declarations: [
        ReferrerPortalComponent,
        ReferrerPortalHomeComponent,       
        ReferrerPortalReferralDetailComponent 
    ],
    imports: [
        CommonModule,
        ReferrerPortalRoutingModule,
        FormsModule,
        FormsFormModule,
        FileManagerViewModule,
        FileManagerModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        LucideIconsModule,
        MatMenuModule,
        MatTabsModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatDialogModule,
        MatDividerModule,
        MatSnackBarModule,        
        MatTooltipModule,
        TdoControlsModule,
        PipeModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReferrerPortalModule { }
